<template>
  <div class="conversion-wrapper" v-if="isFulfilled" @mouseenter="onMouseEnter">
    <div class="header">{{ $t('dashboard.conversionRate.heading') }}</div>
    <div class="usd-rate-container" v-if="rate">
      <img
        src="@/assets/images/common/usa-flag.svg"
        alt="usa flag"
        class="mr-2"
      />
      <sup>{{ $t('dashboard.conversionRate.usd') }}</sup>
      {{ $t('dashboard.conversionRate.oneUSD') }}
    </div>
    <div v-else>
      <div class="usd-rate-container flex justify-content-center mb-3">
        <img
          src="@/assets/images/common/usa-flag.svg"
          alt="usa flag"
          class="mr-2"
        />
        <b-icon-arrow-left-right class="mr-2" />
        <img src="@/assets/images/common/india-flag.svg" alt="india flag" />
      </div>
    </div>
    <div class="inr-rate-container" v-if="rate">
      <img
        src="@/assets/images/common/india-flag.svg"
        alt="india flag"
        class="mr-2"
      />
      <template>
        <sup>{{ $t('dashboard.conversionRate.inr') }} </sup>
        {{ rate }}
      </template>
    </div>
    <div v-else class="inr-rate-container warning">
      <b-icon-exclamation-triangle class="mr-2 color-warning warning-icon" />
      <div class="warning-text">
        {{ $t('dashboard.conversionRate.conversionRateFailed') }}
      </div>
    </div>
    <div class="info-text">
      <b-icon-info-circle scale="1.6" class="mr-2 color-sky-blue-color" />
      {{ $t('dashboard.conversionRate.note') }}
    </div>
    <div v-if="isINREnabled" class="enabled-inr-payments">
      {{ $t('dashboard.conversionRate.chip') }}
    </div>
  </div>
  <div v-else>
    <loader />
  </div>
</template>
<script>
import Loader from '@/components/common/Loader'

export default {
  props: {
    rate: String,
    isFulfilled: Boolean,
    isINREnabled: Boolean
  },
  components: {
    Loader
  },
  methods: {
    onMouseEnter() {
      this.$mpTrack('Mouse track on the currency conversion tile')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/_palette.scss';

.conversion-wrapper {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: $sky-blue-50;
  padding: 12px;
  margin: 0 auto;
  text-align: center;
  .header {
    font-weight: 700;
    font-size: 18px;
    line-height: 21px;
    text-align: center;
    color: $noble-blue-500;
    margin-bottom: 16px;
  }
  .usd-rate-container {
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    color: $noble-blue-500;
    margin-bottom: 8px;
  }
  .inr-rate-container {
    display: flex;
    margin: auto;
    justify-content: center;
    align-items: center;
    padding: 12px 24px;
    width: 100%;
    max-width: 178px;
    background: $white;
    box-shadow: 0px 6px 12px rgba(10, 46, 87, 0.2);
    border-radius: 4px;
    font-weight: 700;
    font-size: 32px;
    line-height: 38px;
    color: $noble-blue-500;
    margin-bottom: 16px;
    &.warning {
      max-width: 240px;
    }
    .warning-icon {
      width: 24px;
      height: 24px;
    }
    .warning-text {
      margin-left: 4px;
      display: inline;
      font-size: 16px;
      font-weight: 700;
      line-height: normal;
      color: $noble-blue-500;
    }
    .color-warning {
      color: $mustard-yellow-500;
    }
  }
  .info-text {
    display: flex;
    justify-content: center;
    font-weight: 500;
    font-size: 8px;
    line-height: 9px;
    color: $noble-blue-500;
  }
  .enabled-inr-payments {
    font-weight: 400;
    font-size: 10px;
    line-height: 14px;
    margin: auto;
    margin-top: 16px;
    padding: 4px 12px;
    color: $noble-blue-500;
    background: $sky-blue-50;
    border: 1px solid $sky-blue-400;
    border-radius: 24px;
  }
}
</style>
